let address = [
    {
        "name": "上海",
        "code": "1",
        "children": []
    },
    {
        "name": "云南",
        "code": "2",
        "children": [
            { "name": "临沧", "code": "35" },
            { "name": "丽江", "code": "36" },
            { "name": "保山", "code": "37" },
            { "name": "大理白族自治州", "code": "38" },
            { "name": "德宏傣族景颇族自治州", "code": "39" },
            { "name": "怒江傈僳族自治州", "code": "40" },
            { "name": "思茅", "code": "41" },
            { "name": "文山壮族苗族自治州", "code": "42" },
            { "name": "昆明", "code": "43" },
            { "name": "昭通", "code": "44" },
            { "name": "普洱", "code": "45" },
            { "name": "曲靖", "code": "46" },
            { "name": "楚雄彝族自治州", "code": "47" },
            { "name": "玉溪", "code": "48" },
            { "name": "红河哈尼族彝族自治州", "code": "49" },
            { "name": "蒙自", "code": "50" },
            { "name": "西双版纳傣族自治州", "code": "51" },
            { "name": "迪庆藏族自治州", "code": "52" }
        ]
    },
    {
        "name": "内蒙古",
        "code": "3",
        "children": [
            { "name": "乌兰察布", "code": "53" },
            { "name": "乌海", "code": "54" },
            { "name": "兴安盟", "code": "55" },
            { "name": "包头", "code": "56" },
            { "name": "呼伦贝尔", "code": "57" },
            { "name": "呼和浩特", "code": "58" },
            { "name": "巴彦淖尔", "code": "59" },
            { "name": "赤峰", "code": "60" },
            { "name": "通辽", "code": "61" },
            { "name": "鄂尔多斯", "code": "62" },
            { "name": "锡林郭勒盟", "code": "63" },
            { "name": "阿拉善盟", "code": "64" }
        ]
    },
    {
        "name": "北京",
        "code": "4",
        "children": []
    },
    {
        "name": "台湾",
        "code": "5",
        "children": [
            { "name": "澎湖县", "code": "430" },
            { "name": "新北市", "code": "431" },
            { "name": "台北市", "code": "432" },
            { "name": "嘉义县", "code": "433" },
            { "name": "高雄市", "code": "434" },
            { "name": "台中市", "code": "435" },
            { "name": "新竹市", "code": "436" },
            { "name": "桃园市", "code": "437" },
            { "name": "基隆市", "code": "438" },
            { "name": "嘉义市", "code": "439" },
            { "name": "云林县", "code": "440" },
            { "name": "屏东县", "code": "441" },
            { "name": "金门县", "code": "442" },
            { "name": "台南市", "code": "443" },
            { "name": "宜兰县", "code": "444" },
            { "name": "花莲县", "code": "445" }
        ]
    },
    {
        "name": "吉林",
        "code": "6",
        "children": [
            { "name": "吉林市", "code": "65" },
            { "name": "四平", "code": "66" },
            { "name": "延吉", "code": "67" },
            { "name": "延边朝鲜族自治州", "code": "68" },
            { "name": "松原", "code": "69" },
            { "name": "白城", "code": "70" },
            { "name": "白山", "code": "71" },
            { "name": "辽源", "code": "72" },
            { "name": "通化", "code": "73" },
            { "name": "长春", "code": "74" }
        ]
    },
    {
        "name": "四川",
        "code": "7",
        "children": [
            { "name": "乐山", "code": "75" },
            { "name": "内江", "code": "76" },
            { "name": "凉山彝族自治州", "code": "77" },
            { "name": "南充", "code": "78" },
            { "name": "宜宾", "code": "79" },
            { "name": "巴中", "code": "80" },
            { "name": "广元", "code": "81" },
            { "name": "广安", "code": "82" },
            { "name": "广汉", "code": "83" },
            { "name": "康定", "code": "84" },
            { "name": "德阳", "code": "85" },
            { "name": "成都", "code": "86" },
            { "name": "攀枝花", "code": "87" },
            { "name": "江油", "code": "88" },
            { "name": "泸州", "code": "89" },
            { "name": "甘孜藏族自治州", "code": "90" },
            { "name": "眉山", "code": "91" },
            { "name": "绵阳", "code": "92" },
            { "name": "自贡", "code": "93" },
            { "name": "西昌", "code": "94" },
            { "name": "资阳", "code": "95" },
            { "name": "达州", "code": "96" },
            { "name": "遂宁", "code": "97" },
            { "name": "都江堰", "code": "98" },
            { "name": "阿坝藏族羌族自治州", "code": "99" },
            { "name": "雅安", "code": "100" }
        ]
    },
    {
        "name": "天津",
        "code": "8",
        "children": []
    },
    {
        "name": "宁夏",
        "code": "9",
        "children": [
            { "name": "中卫", "code": "101" },
            { "name": "吴忠", "code": "102" },
            { "name": "固原", "code": "103" },
            { "name": "石嘴山", "code": "104" },
            { "name": "银川", "code": "105" }
        ]
    },
    {
        "name": "安徽",
        "code": "10",
        "children": [
            { "name": "亳州", "code": "106" },
            { "name": "六安", "code": "107" },
            { "name": "合肥", "code": "108" },
            { "name": "安庆", "code": "109" },
            { "name": "宣城", "code": "110" },
            { "name": "宿州", "code": "111" },
            { "name": "巢湖", "code": "112" },
            { "name": "池州", "code": "113" },
            { "name": "淮北", "code": "114" },
            { "name": "淮南", "code": "115" },
            { "name": "滁州", "code": "116" },
            { "name": "芜湖", "code": "117" },
            { "name": "蚌埠", "code": "118" },
            { "name": "铜陵", "code": "119" },
            { "name": "阜阳", "code": "120" },
            { "name": "马鞍山", "code": "121" },
            { "name": "黄山", "code": "122" }
        ]
    },
    {
        "name": "山东",
        "code": "11",
        "children": [
            { "name": "东营", "code": "123" },
            { "name": "临沂", "code": "124" },
            { "name": "威海", "code": "125" },
            { "name": "德州", "code": "126" },
            { "name": "日照", "code": "127" },
            { "name": "曲阜", "code": "128" },
            { "name": "枣庄", "code": "129" },
            { "name": "泰安", "code": "130" },
            { "name": "泰山", "code": "131" },
            { "name": "济南", "code": "132" },
            { "name": "济宁", "code": "133" },
            { "name": "淄博", "code": "134" },
            { "name": "滨州", "code": "135" },
            { "name": "潍坊", "code": "136" },
            { "name": "青州", "code": "136001" },
            { "name": "烟台", "code": "137" },
            { "name": "章丘", "code": "138" },
            { "name": "聊城", "code": "139" },
            { "name": "胶州", "code": "140" },
            { "name": "莱芜", "code": "141" },
            { "name": "莱阳", "code": "142" },
            { "name": "菏泽", "code": "143" },
            { "name": "诸城", "code": "144" },
            { "name": "青岛", "code": "145" }
        ]
    },
    {
        "name": "山西",
        "code": "12",
        "children": [
            { "name": "临汾", "code": "146" },
            { "name": "介休", "code": "147" },
            { "name": "吕梁", "code": "148" },
            { "name": "大同", "code": "149" },
            { "name": "太原", "code": "150" },
            { "name": "忻州", "code": "151" },
            { "name": "晋中", "code": "152" },
            { "name": "晋城", "code": "153" },
            { "name": "朔州", "code": "154" },
            { "name": "汾阳", "code": "155" },
            { "name": "运城", "code": "156" },
            { "name": "长治", "code": "157" },
            { "name": "阳泉", "code": "158" }
        ]
    },
    {
        "name": "广东",
        "code": "13",
        "children": [
            { "name": "东莞", "code": "159" },
            { "name": "中山", "code": "160" },
            { "name": "云浮", "code": "161" },
            { "name": "佛山", "code": "162" },
            { "name": "南海", "code": "163" },
            { "name": "广州", "code": "164" },
            { "name": "惠州", "code": "165" },
            { "name": "惠阳", "code": "166" },
            { "name": "揭阳", "code": "167" },
            { "name": "普宁", "code": "168" },
            { "name": "梅州", "code": "169" },
            { "name": "汕头", "code": "170" },
            { "name": "汕尾", "code": "171" },
            { "name": "江门", "code": "172" },
            { "name": "河源", "code": "173" },
            { "name": "深圳", "code": "174" },
            { "name": "清远", "code": "175" },
            { "name": "湛江", "code": "176" },
            { "name": "潮州", "code": "160001" },
            { "name": "珠海", "code": "178" },
            { "name": "肇庆", "code": "179" },
            { "name": "茂名", "code": "180" },
            { "name": "阳江", "code": "181" },
            { "name": "韶关", "code": "182" },
            { "name": "顺德", "code": "183" },
            { "name": "高州", "code": "184" }
        ]
    },
    {
        "name": "广西",
        "code": "14",
        "children": [
            { "name": "北海", "code": "185" },
            { "name": "南宁", "code": "186" },
            { "name": "崇左", "code": "187" },
            { "name": "来宾", "code": "188" },
            { "name": "柳州", "code": "189" },
            { "name": "桂林", "code": "190" },
            { "name": "梧州", "code": "191" },
            { "name": "河池", "code": "192" },
            { "name": "玉林", "code": "193" },
            { "name": "百色", "code": "194" },
            { "name": "贵港", "code": "195" },
            { "name": "贺州", "code": "196" },
            { "name": "钦州", "code": "197" },
            { "name": "防城港", "code": "198" }
        ]
    },
    {
        "name": "新疆",
        "code": "15",
        "children": [
            { "name": "乌鲁木齐", "code": "199" },
            { "name": "伊宁", "code": "200" },
            { "name": "伊犁哈萨克自治州", "code": "201" },
            { "name": "克孜勒苏柯尔克孜自治州", "code": "202" },
            { "name": "克拉玛依", "code": "203" },
            { "name": "博尔塔拉蒙古自治州", "code": "204" },
            { "name": "吐鲁番地区", "code": "205" },
            { "name": "和田地区", "code": "206" },
            { "name": "哈密地区", "code": "207" },
            { "name": "喀什地区", "code": "208" },
            { "name": "塔城地区", "code": "209" },
            { "name": "巴音郭楞蒙古自治州", "code": "210" },
            { "name": "库尔勒", "code": "211" },
            { "name": "昌吉回族自治州", "code": "212" },
            { "name": "石河子", "code": "213" },
            { "name": "阿克苏地区", "code": "214" },
            { "name": "阿勒泰地区", "code": "215" },
            { "name": "阿拉尔", "code": "216" }
        ]
    },
    {
        "name": "江苏",
        "code": "16",
        "children": [
            { "name": "南京", "code": "217" },
            { "name": "南通", "code": "218" },
            { "name": "句容", "code": "219" },
            { "name": "太仓", "code": "220" },
            { "name": "宿迁", "code": "221" },
            { "name": "常州", "code": "222" },
            { "name": "常熟", "code": "223" },
            { "name": "张家港", "code": "224" },
            { "name": "徐州", "code": "225" },
            { "name": "扬州", "code": "226" },
            { "name": "无锡", "code": "227" },
            { "name": "昆山", "code": "228" },
            { "name": "泰州", "code": "229" },
            { "name": "涟水", "code": "230" },
            { "name": "淮安", "code": "231" },
            { "name": "盐城", "code": "232" },
            { "name": "苏州", "code": "233" },
            { "name": "连云港", "code": "234" },
            { "name": "镇江", "code": "235" },
            { "name": "丹阳", "code": "235001" }
        ]
    },
    {
        "name": "江西",
        "code": "17",
        "children": [
            { "name": "上饶", "code": "236" },
            { "name": "九江", "code": "237" },
            { "name": "南昌", "code": "238" },
            { "name": "吉安", "code": "239" },
            { "name": "宜春", "code": "240" },
            { "name": "抚州", "code": "241" },
            { "name": "新余", "code": "242" },
            { "name": "景德镇", "code": "243" },
            { "name": "萍乡", "code": "244" },
            { "name": "赣州", "code": "245" },
            { "name": "鹰潭", "code": "246" }
        ]
    },
    {
        "name": "河北",
        "code": "18",
        "children": [
            { "name": "三河", "code": "247" },
            { "name": "任丘", "code": "130982" },
            { "name": "保定", "code": "130600" },
            { "name": "唐山", "code": "130200" },
            { "name": "廊坊", "code": "131000" },
            { "name": "张家口", "code": "130700" },
            { "name": "承德", "code": "130800" },
            { "name": "沧州", "code": "130900" },
            { "name": "石家庄", "code": "130100" },
            { "name": "秦皇岛", "code": "130300" },
            { "name": "衡水", "code": "131100" },
            { "name": "邢台", "code": "130500" },
            { "name": "邯郸", "code": "130400" },
            { "name": "鹿泉", "code": "130110" }
        ]
    },
    {
        "name": "河南",
        "code": "19",
        "children": [
            { "name": "三门峡", "code": "261" },
            { "name": "信阳", "code": "262" },
            { "name": "南阳", "code": "263" },
            { "name": "周口", "code": "264" },
            { "name": "商丘", "code": "265" },
            { "name": "安阳", "code": "266" },
            { "name": "平顶山", "code": "267" },
            { "name": "开封", "code": "268" },
            { "name": "新乡", "code": "269" },
            { "name": "永城", "code": "270" },
            { "name": "洛阳", "code": "271" },
            { "name": "济源", "code": "272" },
            { "name": "漯河", "code": "273" },
            { "name": "濮阳", "code": "274" },
            { "name": "焦作", "code": "275" },
            { "name": "登封", "code": "276" },
            { "name": "许昌", "code": "277" },
            { "name": "郑州", "code": "278" },
            { "name": "驻马店", "code": "279" },
            { "name": "鹤壁", "code": "280" }
        ]
    },
    {
        "name": "浙江",
        "code": "20",
        "children": [
            { "name": "东阳", "code": "281" },
            { "name": "临安", "code": "282" },
            { "name": "丽水", "code": "283" },
            { "name": "义乌", "code": "284" },
            { "name": "乐清", "code": "285" },
            { "name": "余姚", "code": "286" },
            { "name": "台州", "code": "287" },
            { "name": "嘉兴", "code": "288" },
            { "name": "宁波", "code": "289" },
            { "name": "富阳", "code": "290" },
            { "name": "杭州", "code": "291" },
            { "name": "海宁", "code": "292" },
            { "name": "温州", "code": "293" },
            { "name": "湖州", "code": "294" },
            { "name": "瑞安", "code": "295" },
            { "name": "绍兴", "code": "296" },
            { "name": "舟山", "code": "297" },
            { "name": "萧山", "code": "298" },
            { "name": "衢州", "code": "299" },
            { "name": "金华", "code": "300" }
        ]
    },
    {
        "name": "海南",
        "code": "21",
        "children": [
            { "name": "三亚", "code": "301" },
            { "name": "五指山", "code": "302" },
            { "name": "儋州", "code": "303" },
            { "name": "文昌", "code": "304" },
            { "name": "海口", "code": "305" },
            { "name": "琼海", "code": "306" }
        ]
    },
    {
        "name": "湖北",
        "code": "22",
        "children": [
            { "name": "仙桃", "code": "307" },
            { "name": "十堰", "code": "308" },
            { "name": "咸宁", "code": "309" },
            { "name": "孝感", "code": "310" },
            { "name": "宜昌", "code": "311" },
            { "name": "恩施土家族苗族自治州", "code": "312" },
            { "name": "武汉", "code": "313" },
            { "name": "潜江", "code": "314" },
            { "name": "神农架", "code": "315" },
            { "name": "荆州", "code": "316" },
            { "name": "荆门", "code": "317" },
            { "name": "襄阳", "code": "318" },
            { "name": "鄂州", "code": "319" },
            { "name": "随州", "code": "320" },
            { "name": "黄冈", "code": "321" },
            { "name": "黄石", "code": "322" }
        ]
    },
    {
        "name": "湖南",
        "code": "23",
        "children": [
            { "name": "吉首", "code": "323" },
            { "name": "娄底", "code": "324" },
            { "name": "岳阳", "code": "325" },
            { "name": "常德", "code": "326" },
            { "name": "张家界", "code": "327" },
            { "name": "怀化", "code": "328" },
            { "name": "株洲", "code": "329" },
            { "name": "永州", "code": "330" },
            { "name": "湘潭", "code": "331" },
            { "name": "湘西土家族苗族自治州", "code": "332" },
            { "name": "益阳", "code": "333" },
            { "name": "耒阳", "code": "334" },
            { "name": "衡阳", "code": "335" },
            { "name": "邵阳", "code": "336" },
            { "name": "郴州", "code": "337" },
            { "name": "长沙", "code": "338" }
        ]
    },
    {
        "name": "澳门",
        "code": "24",
        "children": []
    },
    {
        "name": "甘肃",
        "code": "25",
        "children": [
            { "name": "临夏回族自治州", "code": "339" },
            { "name": "兰州", "code": "340" },
            { "name": "合作", "code": "341" },
            { "name": "嘉峪关", "code": "342" },
            { "name": "天水", "code": "343" },
            { "name": "定西", "code": "344" },
            { "name": "平凉", "code": "345" },
            { "name": "庆阳", "code": "346" },
            { "name": "张掖", "code": "347" },
            { "name": "榆中", "code": "348" },
            { "name": "武威", "code": "349" },
            { "name": "甘南藏族自治州", "code": "350" },
            { "name": "白银", "code": "351" },
            { "name": "酒泉", "code": "352" },
            { "name": "金昌", "code": "353" },
            { "name": "陇南", "code": "354" }
        ]
    },
    {
        "name": "福建",
        "code": "26",
        "children": [
            { "name": "三明", "code": "355" },
            { "name": "南平", "code": "356" },
            { "name": "厦门", "code": "357" },
            { "name": "宁德", "code": "358" },
            { "name": "永安", "code": "359" },
            { "name": "泉州", "code": "360" },
            { "name": "漳州", "code": "361" },
            { "name": "福州", "code": "362" },
            { "name": "莆田", "code": "363" },
            { "name": "龙岩", "code": "364" }
        ]
    },
    {
        "name": "西藏",
        "code": "27",
        "children": [
            { "name": "山南地区", "code": "365" },
            { "name": "拉萨", "code": "366" },
            { "name": "日喀则", "code": "367" },
            { "name": "昌都", "code": "368" },
            { "name": "林芝", "code": "369" },
            { "name": "那曲地区", "code": "370" },
            { "name": "阿里地区", "code": "371" }
        ]
    },
    {
        "name": "贵州",
        "code": "28",
        "children": [
            { "name": "六盘水", "code": "372" },
            { "name": "兴义", "code": "373" },
            { "name": "凯里", "code": "374" },
            { "name": "安顺", "code": "375" },
            { "name": "毕节", "code": "376" },
            { "name": "贵阳", "code": "377" },
            { "name": "遵义", "code": "378" },
            { "name": "都匀", "code": "379" },
            { "name": "铜仁", "code": "380" },
            { "name": "黔东南苗族侗族自治州", "code": "381" },
            { "name": "黔南布依族苗族自治州", "code": "382" },
            { "name": "黔西南布依族苗族自治州", "code": "383" }
        ]
    },
    {
        "name": "辽宁",
        "code": "29",
        "children": [
            { "name": "丹东", "code": "384" },
            { "name": "大连", "code": "385" },
            { "name": "抚顺", "code": "386" },
            { "name": "朝阳", "code": "387" },
            { "name": "本溪", "code": "388" },
            { "name": "沈阳", "code": "389" },
            { "name": "盘锦", "code": "390" },
            { "name": "营口", "code": "391" },
            { "name": "葫芦岛", "code": "392" },
            { "name": "辽阳", "code": "393" },
            { "name": "铁岭", "code": "394" },
            { "name": "锦州", "code": "395" },
            { "name": "阜新", "code": "396" },
            { "name": "鞍山", "code": "397" }
        ]
    },
    {
        "name": "重庆",
        "code": "30",
        "children": []
    },
    {
        "name": "陕西",
        "code": "31",
        "children": [
            { "name": "咸阳", "code": "398" },
            { "name": "商洛", "code": "399" },
            { "name": "安康", "code": "400" },
            { "name": "宝鸡", "code": "401" },
            { "name": "延安", "code": "402" },
            { "name": "榆林", "code": "403" },
            { "name": "汉中", "code": "404" },
            { "name": "渭南", "code": "405" },
            { "name": "西安", "code": "406" },
            { "name": "铜川", "code": "407" }
        ]
    },
    {
        "name": "青海",
        "code": "32",
        "children": [
            { "name": "果洛藏族自治州", "code": "408" },
            { "name": "海东", "code": "409" },
            { "name": "海北藏族自治州", "code": "410" },
            { "name": "海南藏族自治州", "code": "411" },
            { "name": "海西蒙古族藏族自治州", "code": "412" },
            { "name": "玉树藏族自治州", "code": "413" },
            { "name": "西宁", "code": "414" },
            { "name": "黄南藏族自治州", "code": "415" }
        ]
    },
    {
        "name": "香港",
        "code": "33",
        "children": []
    },
    {
        "name": "黑龙江",
        "code": "34",
        "children": [
            { "name": "七台河", "code": "416" },
            { "name": "伊春", "code": "417" },
            { "name": "佳木斯", "code": "418" },
            { "name": "双城", "code": "419" },
            { "name": "双鸭山", "code": "420" },
            { "name": "哈尔滨", "code": "421" },
            { "name": "大兴安岭地区", "code": "422" },
            { "name": "大庆", "code": "423" },
            { "name": "牡丹江", "code": "424" },
            { "name": "绥化", "code": "425" },
            { "name": "鸡西", "code": "426" },
            { "name": "鹤岗", "code": "427" },
            { "name": "黑河", "code": "428" },
            { "name": "齐齐哈尔", "code": "429" }
        ]
    }
]

export default address


// WEBPACK FOOTER //
// ./src/until/qttaddress.js